<template>
  <div class="relative nowrap" style="margin-left: -3px;">
    <grid-header-cell
      class="dib v-top ba bg-near-white relative tc vg-th"
      v-for="(col, index) in _.filter(columns,{shown:true})"
      v-bind:key="index"
      :col="col"
      :value="getColumnName(col)"
      :width="col.pixel_width || 0"
      :style="'height: '+(rowHeight+1)+'px'"
      @column-resizer-mousedown="onColumnResizerMousedown"
      @determine-auto-width="onHeaderCellDetermineWidth"
      @showDropdown="$emit('toggleDropdown',columns[index],!columns[index].showDropdown)"
      @sort="(order)=>{$emit('sort',col,order)}"
      @applyFilter="(filter)=>{$emit('applyFilter',col,filter)}"
    ></grid-header-cell>
  </div>
</template>

<script>
  import {
    DEFAULT_ROW_HEIGHT
  } from './constants'
  import _ from 'lodash'
  import GridHeaderCell from './GridHeaderCell.vue'
  import GridCellCheckbox from './GridCellCheckbox.vue'

  export default {
    props: {
      'row-height': {
        type: Number,
        default: DEFAULT_ROW_HEIGHT
      },
      'columns': {
        type: Array,
        required: true
      }
    },
    components: {
      GridHeaderCell , GridCellCheckbox
    },
    beforeMount(){

    },
    mounted(){
    },
    methods: {
      getColumnName(col) {
        return _.get(col, 'name', '')
      },
      onColumnResizerMousedown(col) {
        this.$emit('start-column-resize', col)
      },
      onHeaderCellDetermineWidth(col, width) {
        this.$emit('determine-cell-auto-width', 'header', col, width)
      }
    }
  }
</script>
